"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../../assets/images");
const ModalViewImage_1 = __importDefault(require("../../../components/modal/ModalViewImage"));
const scale_1 = require("../../../utils/scale");
const ItemImage_1 = __importDefault(require("./ItemImage"));
const ListImageItemDetail = (props) => {
    const { data, } = props;
    const [dataImage, setDataImage] = (0, react_1.useState)([]);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [index, setIndex] = (0, react_1.useState)(0);
    const { width: _width, height } = react_native_1.Dimensions.get('window');
    const width = react_native_1.Platform.OS === 'web' ? (_width >= 1024 ? 375 : _width) : _width;
    (0, react_1.useEffect)(() => {
        if (data?.length > 0) {
            setDataImage(data);
        }
        else if (!data || data?.length == 0) {
            setDataImage([]);
        }
    }, [data]);
    if (dataImage?.length == 0) {
        return;
    }
    if (dataImage.length == 1) {
        return (react_1.default.createElement(react_native_1.View, { style: {
                marginTop: (0, scale_1.scale)(8),
                position: 'relative',
                width: (0, scale_1.scale)(343),
                height: (0, scale_1.scale)(160),
                borderRadius: (0, scale_1.scale)(8),
            } },
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                    setVisible(true), setIndex(0);
                } },
                react_1.default.createElement(react_native_1.Image, { source: dataImage[0].url, style: {
                        width: (0, scale_1.scale)(343),
                        height: (0, scale_1.scale)(160),
                        overflow: 'hidden',
                        resizeMode: 'contain',
                    } })),
            react_1.default.createElement(ModalViewImage_1.default, { visible: visible, onClose: () => setVisible(false), data: data, index: index })));
    }
    if (dataImage.length > 1) {
        return (react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, style: {
                flexDirection: 'column',
                flexWrap: 'wrap',
                paddingLeft: (0, scale_1.scale)(3),
            }, showsHorizontalScrollIndicator: scale_1.isPC },
            dataImage?.map((item, index) => {
                return (react_1.default.createElement(react_native_1.Pressable, { key: index, disabled: !item.url, onPress: () => {
                        setVisible(true), setIndex(index);
                    } },
                    react_1.default.createElement(ItemImage_1.default, { uri: item.url ? item.url : images_1.images?.NoImages })));
            }),
            react_1.default.createElement(ModalViewImage_1.default, { visible: visible, onClose: () => setVisible(false), data: data, index: index })));
    }
};
exports.default = ListImageItemDetail;
